import Head from 'next/head'
import { type ReactElement, useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import Breadcrumbs from '../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { executeRetrieveRecurringPaymentsSearch } from '../../../../shared/apiUtils/executeRetrieveRecurringPaymentsSearch'
import { determineBrowserTabName } from '../../../../shared/themes/logoFunctions'
import ErrorBoundary from '../../../../shared/components/errorBoundary/ErrorBoundary'
import { type FilterBoxProps } from '../../../../shared/components/ui/filterBox/FilterBox'
import { RecurringPaymentsTable } from './components/RecurringPaymentsTable'
import AddRecurringChargeButton from './components/RecurringPaymentsTable/components/AddRecurringChargeButton'
import { SearchBox } from './components/FiltersBox/components/SearchBox'
import FiltersRow from './components/FiltersRow/FiltersRow'
import { clearRecurringFilters, determineFilterRow } from './components/FiltersRow/utils'
import { recurringPaymentsProxy } from './recurringPaymentsProxy'

export function RecurringPaymentsTableContainer (): ReactElement {
  const { filters } = useSnapshot(recurringPaymentsProxy)

  const [filterRow, setFilterRow] = useState<FilterBoxProps[]>([])

  const handleClearAll = (): void => {
    clearRecurringFilters()
    setFilterRow([])
  }

  useEffect(() => {
    const updatedFilters = determineFilterRow()
    setFilterRow(updatedFilters)
  }, [filters])

  useEffect(() => {
    void executeRetrieveRecurringPaymentsSearch({ displayLoader: true })
  }, [])
  return (
    <>
      <Head>
        <title>Recurring Charges- {determineBrowserTabName()}</title>
      </Head>
      <Breadcrumbs breadcrumbs={[{ text: 'Recurring Charges' }]} />
      <div className="flex justify-end my-4">
        <AddRecurringChargeButton />
      </div>

      <div className="bg-white shadow rounded pt-1 mb-32">
        <ErrorBoundary>
          <div className="flex">
            <SearchBox />
          </div>
          <div className="flex flex-row">
            <FiltersRow filters={filterRow} onClearAll={handleClearAll} />
          </div>
          <RecurringPaymentsTable />
        </ErrorBoundary>
      </div>
    </>
  )
}
